import { useState } from 'react';

function useTransportModeFilter(initialSelectedFilters) {
  const transportModeFilter = initialSelectedFilters.find(
    (filter) => filter.uid === 'other.transport_mode.items[]',
  );
  const transportModeFilterValue =
    transportModeFilter?.subOptions?.map(({ value }) => value) || [];
  const [transportModeOptions, setTransportModeOptions] = useState<string[]>(
    transportModeFilterValue,
  );

  const onToggleTransportMode = (value: string) => {
    const isSelected = transportModeOptions.some((item) => item === value);
    if (isSelected) {
      setTransportModeOptions(
        (prevDuration) => prevDuration.filter((item) => item !== value) || [],
      );
    } else {
      setTransportModeOptions((prevDuration) => [...prevDuration, value]);
    }
  };

  return {
    transportModeOptions,
    onToggleTransportMode,
  };
}

export default useTransportModeFilter;
